import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const Tokenomics = ({homepagedata,homepagetokendata,buy}) => { 
    const {t} = useTranslation();
    return (            
        <section className="TknmcsSec">
            <div className="container">
                <div className="TknmcsDv" >
                    <h3>{t('Token Distribution & Tokenomics')}</h3>
                    <div className="row">
                        <div className="col-lg-6">
                            <img src={require('../../../assets/images/piechart.png')} className='d-block mx-auto' alt='' />
                            
                        </div>
                        <div className='ml-lg-auto col-lg-5'>
                            <div className='TknmcsDts'>
                            {homepagetokendata?.map((rowdata) => (
                             <div key={rowdata} className='TknmcsDtsInr'>
                                    <h4>{t(rowdata?.title)}</h4>
                                    <h5>{rowdata?.percentage}%</h5>
                                    </div>
                               
                             ))}



                            </div>
                            <button className="btn CmnBtn h-46" onClick={buy}>{t('Buy KKOG COIN')}<img src={require('../../../assets/images/cart.gif')} className='ml-3' alt='' width="23px" /></button>
                        </div>
                    </div>                    
                </div>
            </div>
            
            <div className='TknMcsGrd' data-aos="zoom-out-left" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-delay="100">
                <div className='container'>
                    <div className="gridbxmain">
                        <div className="gridebxTokenomics" style={{height: '15px'}}>
                            <div className="smborder"></div>
                            <div className="smborder"></div>
                            <div className="smborder"></div>
                            <div className="smborder"></div>
                            <div className="smborder"></div>
                            <div className="smborder-bottom"></div>
                        </div>
                        <div className="gridebxTokenomics">
                            <div className="smborder"></div>
                            <div className="">
                                <div className="tokenamicsbx">
                                    <div className='tokenamicsbxInr'>
                                        <div className="title"><span> {t('Tokens Network')} </span></div>
                                        <div className="label">{homepagedata?.token_network}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="tokenamicsbx">
                                    <div className='tokenamicsbxInr'>
                                        <div className="title"><span>{t('Token Name')}</span></div>
                                        <div className="label">{homepagedata?.token_name}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="tokenamicsbx">
                                    <div className='tokenamicsbxInr'>
                                        <div className="title"><span>{t('Token Ticker')}</span></div>
                                        <div className="label">${homepagedata?.token_ticker}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="tokenamicsbx">
                                    <div className='tokenamicsbxInr'>
                                        <div className="title"><span>{t('Decimal')}</span></div>
                                        <div className="label">{homepagedata?.decimal}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="smborder-bottom"></div>
                            </div>
                            <div className="gridebxTokenomics gridebxTokenomics1">
                            <div className="smborder"></div>
                            <div className="">
                                <div className="tokenamicsbx">
                                    <div className='tokenamicsbxInr'>
                                        <div className="title"><span>{t('Total Supply')}</span></div>
                                        <div className="label">{homepagedata?.total_supply}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="tokenamicsbx">
                                    <div className='tokenamicsbxInr'>
                                        <div className="title"><span>{t('Mintable')}</span></div>
                                        <div className="label">{homepagedata?.mintable}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="tokenamicsbx">
                                    <div className='tokenamicsbxInr'>
                                        <div className="title"><span>{t('Burnable')}</span></div>
                                        <div className="label">{homepagedata?.burnable}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="smborder-bottom"></div>
                        </div>


            
                        <div className="gridebxTokenomics gridebxTokenomics1"  style={{height: '15px'}}>
                            <div className="border-right"></div>
                            <div className="border-right"></div>
                            <div className="border-right"></div>
                            <div className="border-right"></div>
                            <div className=""></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
   
}
Tokenomics.propTypes = {
    homepagedata: PropTypes.shape({
        token_network: PropTypes.any,
        token_name: PropTypes.any,
        token_ticker: PropTypes.any,
        decimal: PropTypes.any,
        total_supply: PropTypes.any,
        mintable: PropTypes.any,
        burnable: PropTypes.any,
    }),
    homepagetokendata: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.any,
            percentage: PropTypes.any,
        })),
    buy: PropTypes.any,

}


export default Tokenomics;

